import { render, staticRenderFns } from "./admission.vue?vue&type=template&id=555fedcb&scoped=true"
import script from "./admission.vue?vue&type=script&lang=js"
export * from "./admission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555fedcb",
  null
  
)

export default component.exports